import { render, staticRenderFns } from "./gamerankblack.vue?vue&type=template&id=7ad87e0c"
import script from "./gamerankblack.vue?vue&type=script&lang=js"
export * from "./gamerankblack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports